import type { Messages } from "../types";

export const sv = {
  "common": {
    "brand": "UN8",
    "brandTag": "Exklusiv kristen dating",
    "continue": "Fortsätt",
    "leave": "Lämna",
    "leaveForNow": "Lämna för nu",
    "yes": "Ja",
    "no": "Nej",
    "goBack": "Gå tillbaka",
    "saving": "Sparar…",
    "submitting": "Skickar…",
    "pleaseWait": "Vänta…",
    "ellipsis": "…",
    "male": "Man",
    "female": "Kvinna",
    "phases": {
      "gate": "Port",
      "verify": "Verifiera",
      "setup": "Setup",
      "profile": "Profil"
    },
    "storageQuota": "Den här telefonen har slut på utrymme för sparade svar. Frigör lagring och försök igen.",
    "storageDisabled": "Den här webbläsaren sparar inte dina svar. Stäng av privat läge eller tillåt webbplatsdata, och ladda om.",
    "charMeta": "{len}/{min} min · {current}/{max}",
    "charMetaMin": "min {min} tecken"
  },
  "welcome": {
    "promise": "Vårt mål är att du tar bort den här appen så snabbt som möjligt.",
    "sub": "UN8 hjälper seriösa kristna singlar att hitta en livspartner — och sedan lämna. Verifierat. Värderingar först. Ingen oändlig swiping.",
    "signedInAs": "Inloggad som {email}",
    "liveServer": " · live-server",
    "deviceOnly": " · endast den här enheten",
    "migrateOffer": "Den här enheten har fortfarande en lokal profil. Ladda upp den till den delade servern så att andra telefoner kan se dig efter moderering? Ingenting laddas upp förrän du väljer.",
    "uploadLocalProfile": "Ladda upp min lokala profil",
    "keepOnDevice": "Behåll den bara på den här enheten",
    "migrateNeedGender": "Välj först Man eller Kvinna i din profil.",
    "migrateDone": "Profiltext uppladdad. Ladda upp ID, video och foton igen så att modereringen kan granska dem.",
    "deleteConfirm": "Radera permanent ditt konto, alla meddelanden och all media (inklusive ID och video) från servern?",
    "accountDeleted": "Konto raderat.",
    "begin": "Börja",
    "continueOnboarding": "Fortsätt onboarding",
    "logIn": "Logga in",
    "logOut": "Logga ut",
    "reviewConsole": "Granskningskonsol",
    "matching": "Matchning",
    "deleteMyAccount": "Radera mitt konto"
  },
  "faith": {
    "eyebrow": "Trosport",
    "title": "Endast kristna",
    "text": "UN8 är en gemenskap av efterföljare till Jesus Kristus, för medlemmar som söker en äktenskapsinriktad partner som delar den tron. Den här porten kan inte hoppas över.",
    "yesTitle": "Jag är kristen",
    "yesBody": "Jag följer Jesus Kristus och söker en äktenskapsinriktad partner som delar denna tro.",
    "noTitle": "Jag är inte kristen",
    "noBody": "UN8 är inte rätt plats för mig — och det är okej.",
    "respectTitle": "Med respekt",
    "respectBody": "UN8 är byggt för en gemenskap, och vi hellre är ärliga än slösar din tid. Använd Lämna nedan, eller Tillbaka, om det här inte är ditt hem.",
    "sharedTitle": "Gemensam grund",
    "sharedBody": "Tro är inte en etikett här. Det är marken ni möts på.",
    "hintNotChristian": "UN8 är för efterföljare till Jesus Kristus. Tryck på Lämna nedan, eller välj det kristna alternativet om det är du.",
    "hintUnset": "Tryck på ”Jag är kristen” för att fortsätta, eller Lämna / Tillbaka om det här inte är ditt hem."
  },
  "rules": {
    "eyebrow": "Gemenskapens förbund",
    "title": "Hur vi behandlar varandra",
    "text": "Bekräfta varje regel. Alla tre krävs. Överträdelser leder till permanent borttagning. Falska profiler bannlyses för alltid.",
    "agreeContinue": "Jag godkänner — fortsätt",
    "respectful": {
      "title": "Var respektfull",
      "description": "Tala och handla med värdighet. Varje person här är skapad till Guds avbild."
    },
    "noSexualContent": {
      "title": "Inget sexuellt innehåll",
      "description": "Inga explicita foton, meddelanden eller förfrågningar. Renhet är inte valfritt här."
    },
    "noDominance": {
      "title": "Dominera eller kontrollera inte",
      "description": "Ingen tvång, manipulation eller press. Kärlek kontrollerar inte."
    },
    "hint": "Bocka i alla tre löften innan du fortsätter."
  },
  "intent": {
    "eyebrow": "",
    "title": "Vad letar du efter?",
    "text": "",
    "marriage": {
      "label": "En livspartner",
      "description": ""
    },
    "discernment": {
      "label": "Allvarlig prövning",
      "description": ""
    },
    "notCasual": {
      "label": "Inget tillfälligt",
      "description": ""
    },
    "hint": "Välj en."
  },
  "account": {
    "eyebrow": "Konto",
    "title": "Skapa din åtkomst",
    "text": "Ditt handle skapar ett stabilt användar-id. Ansökan, verifiering, likes och matcher binds alla till det id:t. Ingen e-post skickas.",
    "recoveryTitle": "Spara din återställningskod",
    "recoveryText": "Visas en gång. Utan den kan en förlorad lösenfras inte återställas i detta slutna test.",
    "savedContinue": "Jag har sparat den — fortsätt",
    "handle": "Handle",
    "handlePlaceholder": "du@exempel.com eller ett kort handle",
    "passphrase": "Lösenfras",
    "passphrasePlaceholder": "Minst 8 tecken",
    "signedInTitle": "Inloggad",
    "signedInBody": "{email} · {userId}",
    "trustTitle": "Tillitsstandard",
    "trustBody": "Ingen profil syns förrän identitetsverifiering är klar och moderering godkänner dig.",
    "continueToVerification": "Fortsätt till verifiering",
    "hintEmail": "Skriv en e-postadress som innehåller @.",
    "hintPassword": "Välj ett lösenord med minst 8 tecken."
  },
  "verify": {
    "intro": {
      "eyebrow": "Verifiering",
      "title": "Tillit är porten",
      "text": "Ladda upp ett myndighets-ID, en bekräftelsevideo och {min}–{max} riktiga foton. Allt går in i en granskningskö innan din profil kan synas.",
      "whyTitle": "Varför vi verifierar",
      "whyBody": "Catfishing och halv sanningar har ingen plats här. Falska profiler bannlyses permanent. Media lagras med status pending_review tills den godkänns.",
      "start": "Starta verifiering"
    },
    "steps": {
      "id": {
        "title": "Myndighets-ID",
        "description": "Pass eller nationellt ID — kamera eller filuppladdning."
      },
      "video": {
        "title": "Bekräftelsevideo",
        "description": "En kort inspelning som visar att du är närvarande."
      },
      "photos": {
        "title": "Riktiga foton",
        "description": "Sju till tio tydliga foton av dig själv."
      },
      "review": {
        "title": "Integritetsgranskning",
        "description": "Uppladdningar förblir pending_review tills personal bekräftar."
      }
    },
    "id": {
      "eyebrow": "Steg 1 av 4",
      "title": "Myndighets-ID",
      "text": "Ta eller ladda upp ditt pass eller nationella ID. Ingenting publiceras offentligt — status förblir pending_review tills personal bekräftar.",
      "savedTitle": "ID sparat",
      "savedBody": "Nästa är en kort bekräftelsevideo av ditt ansikte, sedan 7 till 10 riktiga foton av dig själv. Fortsätt låses upp när detta ID visar sparat.",
      "hint": "Ta eller ladda upp ett foto av ditt myndighets-ID, och vänta tills det står sparat."
    },
    "video": {
      "eyebrow": "Steg 2 av 4",
      "title": "Bekräftelsevideo",
      "text": "Spela in ett kort klipp eller ladda upp ett. Titta in i kameran. Tala tydligt. Detta visar att du är närvarande — inte ett skrapat galleri.",
      "hint": "Spela in en kort bekräftelsevideo, och vänta tills det står sparat."
    },
    "photos": {
      "eyebrow": "Steg 3 av 4",
      "title": "Riktiga foton",
      "text": "Lägg till {min}–10 senaste foton av dig själv. Använd kameran eller ditt bibliotek. Tryck × för att ta bort en bild.",
      "continueToReview": "Fortsätt till granskning",
      "hint": "Lägg till {min} till 10 tydliga foton av dig själv. Fortsätt låses upp när de är sparade."
    },
    "review": {
      "eyebrow": "Steg 4 av 4",
      "title": "Integritetsgranskning",
      "text": "Media är köad som pending_review{underUser}. Matcher och likes använder samma id.",
      "underUser": " under användare {userId}",
      "governmentId": "Myndighets-ID",
      "confirmationVideo": "Bekräftelsevideo",
      "photos": "Foton",
      "missing": "Saknas",
      "filesReady": "{count} filer klara",
      "submittedTitle": "Skickat för granskning",
      "submittedText": "Ansöknings-id är lika med auth-användar-id så att godkänn → pool och ömsesidiga likes hålls i linje.",
      "submitContinue": "Skicka & fortsätt"
    }
  },
  "setup": {
    "eyebrow": "Kontoinställning",
    "title": "Berätta sanningen om dig själv",
    "text": "Dessa svar formar matchning och syns i granskning. Mjuka lögner slösar allas tid — inklusive din.",
    "beginSetup": "Börja setup",
    "pillars": {
      "faith": {
        "name": "Tro",
        "text": "Varför du följer Kristus."
      },
      "character": {
        "name": "Karaktär",
        "text": "Lojalitet, ärlighet, passion, engagemang — betygsatt 1–10."
      },
      "story": {
        "name": "Berättelse",
        "text": "Vem du är och vad du söker."
      },
      "life": {
        "name": "Liv",
        "text": "Hobbyer, läsning och yrke."
      }
    },
    "whyChristian": {
      "eyebrow": "Tro",
      "title": "Varför är du kristen?",
      "text": "Ett kort, ärligt svar. Inte en predikan — en anledning som är din.",
      "label": "Ditt svar",
      "placeholder": "t.ex. Jag mötte Kristus i en tid av förlust och har följt Honom sedan…",
      "hint": "Skriv minst {min} tecken om varför du följer Jesus."
    }
  },
  "scales": {
    "eyebrow": "Karaktärsskalor",
    "title": "Betygsätt dig själv ärligt",
    "text": "Lojalitet, ärlighet, passion, engagemang — var och en från 1 till 10. Uppblåsta siffror missmatchar dig bara senare. Du måste sätta varje skala för att fortsätta.",
    "loyalty": {
      "label": "Nivå av lojalitet",
      "hint": "Var ärlig — hur troget står du bakom dem du älskar?"
    },
    "honesty": {
      "label": "Nivå av ärlighet",
      "hint": "Hur konsekvent berättar du den fulla sanningen?"
    },
    "passion": {
      "label": "Hur passionerad är du?",
      "hint": "Övertygelse och djup — inte performance."
    },
    "commitment": {
      "label": "Nivå av engagemang",
      "hint": "Hur redo är du att bygga något som varar?"
    },
    "hint": "Flytta varje reglage så att ett tal syns — ingen får stanna som ett streck."
  },
  "about": {
    "eyebrow": "Om dig",
    "title": "Beskriv dig själv i några meningar",
    "text": "Vem du är när ingen spelar. Temperament, rytm, vad som betyder något dag för dag.",
    "label": "Om dig",
    "placeholder": "Tysta morgnar, seriös om familj, skrattar lätt, föredrar djup framför brus…",
    "hint": "Skriv minst {min} tecken om dig själv."
  },
  "looking": {
    "eyebrow": "Partner",
    "title": "Vad letar du efter?",
    "text": "Huvudsakliga karaktärsdrag du önskar hos en potentiell partner — inte en shoppinglista med utseende.",
    "label": "Önskade karaktärsdrag",
    "placeholder": "t.ex. Ståndaktig tro, emotionell mognad, vänlighet under stress…",
    "hint": "Skriv minst {min} tecken om partnern du hoppas på."
  },
  "loveReady": {
    "eyebrow": "Tröskel",
    "title": "Är du redo att möta ditt livs kärlek?",
    "text": "UN8 finns så att seriösa singlar hittar en partner — och sedan tar bort appen. Endast ”Ja” låser upp fortsätt.",
    "yesTitle": "Ja — jag är redo",
    "yesBody": "Jag är här för att möta min person med klarhet och mod.",
    "noTitle": "Inte ännu",
    "noBody": "Om du bara bläddrar passar den här gemenskapen inte.",
    "comeBackTitle": "Kom tillbaka när du är redo",
    "comeBackBody": "UN8 är för människor som är beredda att mötas — inte att samla alternativ. Använd Lämna nedan om du vill stanna upp nu. Dina svar sparas på den här telefonen.",
    "hintNo": "Endast ”Ja” fortsätter. Om du inte är redo, tryck på Lämna för nu — dina svar stannar på den här telefonen.",
    "hintUnset": "Tryck på Ja om du är redo att möta någon för äktenskap."
  },
  "lifestyle": {
    "eyebrow": "Livsstil",
    "title": "Hur du lever dag för dag",
    "text": "Sport, hobbyer, läsning och yrke — praktiska signaler för verklig kompatibilitet.",
    "hobbies": "Nuvarande sport eller hobbyer",
    "hobbiesPlaceholder": "Vad du aktivt gör — inte vad du gjorde en gång.",
    "reading": "Läser du?",
    "readingHint": "1 = nästan aldrig · 10 = dagligen, djup läsning",
    "profession": "Yrke / sektor",
    "professionPlaceholder": "t.ex. Vård · Programvara · Utbildning · Hantverk",
    "hintHobbies": "Namnge minst en sport eller hobby du faktiskt gör.",
    "hintReading": "Skjut ”Läser du?” så att ett tal från 1 till 10 syns.",
    "hintProfession": "Skriv arbetet du gör, även ett kort ord."
  },
  "faithDepth": {
    "eyebrow": "Matchning · Tro",
    "title": "Hur central är din tro?",
    "text": "Att tjäna Gud — hur viktigt i ditt liv? Svara ärligt. Matchning använder detta för djup, inte performance.",
    "serving": "Att tjäna Gud — vikt",
    "servingHint": "10% … 100%. Skjut i steg om 10.",
    "keepsCommandments": "Håller du buden?",
    "grewUpInChurch": "Växte du upp i kyrkan?",
    "churchAttendance": "Kyrkobesök",
    "frequent": {
      "label": "Ofta",
      "hint": "Regelbundet samling med Kristi kropp."
    },
    "seldom": {
      "label": "Sällan",
      "hint": "Ibland, inte en veckorytm."
    },
    "never": {
      "label": "Aldrig",
      "hint": "Deltar inte för närvarande."
    },
    "spreadsGospel": "Sprider du evangeliet?",
    "hasIdols": "Har du avgudar?",
    "hintServing": "Skjut hur viktigt det är att tjäna Gud i ditt liv.",
    "hintCommandments": "Svara om du håller buden — Ja eller Nej.",
    "hintGrewUp": "Svara om du växte upp i kyrkan — Ja eller Nej.",
    "hintAttendance": "Välj hur ofta du går i kyrkan.",
    "hintGospel": "Svara om du delar evangeliet — Ja eller Nej.",
    "hintIdols": "Svara om du har avgudar — Ja eller Nej."
  },
  "character": {
    "eyebrow": "Matchning · Karaktär",
    "title": "Vem du är hemma",
    "text": "Karaktär för frieri — fredsskapande, manér, ärlighet. Uppblåsta svar missmatchar dig bara senare.",
    "peacemaker": "Är du en fredsstiftare?",
    "homebuilder": "Är du en hembyggare?",
    "humorous": "Är du humoristisk?",
    "caring": "Omsorgsfull och tillgiven?",
    "peacefulHome": "Vill du ha ett fridfullt hem — fritt från bråk?",
    "manners": "God ton?",
    "honestyRating": "Ärlighetsbetyg på detta formulär",
    "honestyHint": "1–10 — hur ärligt svarar du?",
    "hintPeacemaker": "Svara Ja eller Nej på varje, börja med fredsstiftare.",
    "hintHomebuilder": "Svara om du är en hembyggare.",
    "hintHumorous": "Svara om du är humoristisk.",
    "hintCaring": "Svara om du är omsorgsfull och tillgiven.",
    "hintPeaceful": "Svara om du vill ha ett fridfullt hem.",
    "hintManners": "Svara om du har god ton.",
    "hintHonesty": "Skjut ditt ärlighetsbetyg från 1 till 10."
  },
  "history": {
    "eyebrow": "Matchning · Historia",
    "title": "Förflutet och beredskap",
    "text": "Substanser, barndom, ärr och om du är redo för en varaktig relation. Sanning här skyddar er båda.",
    "marijuana": "Har du använt marijuana?",
    "lsd": "Har du använt LSD?",
    "otherDrugs": "Har du använt andra droger?",
    "addicted": "Har du varit beroende?",
    "childhood": "Stabil, kärleksfull barndom?",
    "scars": "Ärr / skadad?",
    "lasting": "Redo för en varaktig relation?",
    "hintStart": "Svara Ja eller Nej på varje på den här sidan, börja överst.",
    "hintLsd": "Svara på LSD-frågan — Ja eller Nej.",
    "hintOtherDrugs": "Svara om du har använt andra droger.",
    "hintAddicted": "Svara om du har varit beroende.",
    "hintChildhood": "Svara om din barndom var stabil och kärleksfull.",
    "hintScars": "Svara om du bär ärr.",
    "hintLasting": "Svara om du är redo för en varaktig relation."
  },
  "appearance": {
    "eyebrow": "Matchning · Utseende",
    "title": "Tatueringar",
    "text": "Dina tatueringar, och om tatueringar hos en partner är acceptabla för dig.",
    "hasTattoos": "Har du tatueringar?",
    "acceptsPartner": "Acceptera tatueringar hos en partner?",
    "hintHas": "Säg om du har tatueringar — Ja eller Nej.",
    "hintAccepts": "Säg om tatueringar hos en partner är acceptabla för dig."
  },
  "home": {
    "eyebrow": "Matchning · Hem & land",
    "title": "Land, färdigheter, självförsörjning",
    "text": "Örter, odla mat, fruktträdgård, preppring, gemenskapsjordbruk, konservering, överlevnad — och eventuella specialfärdigheter.",
    "herbKnowledge": "Örtkunskap?",
    "plantOwn": "Odlar du egen frukt och grönsaker?",
    "fruitForest": "Intresserad av en fruktträdgård?",
    "prepping": "Förbereder du för katastrofer?",
    "communityFarming": "Gemenskapsjordbruk / självständigt liv?",
    "canning": "Konservering?",
    "survival": "Överlevnadsfärdigheter?",
    "specialSkills": "Specialfärdigheter (valfritt)",
    "specialPlaceholder": "Allt annat du tar med till ett hushåll eller land…",
    "hintStart": "Svara Ja eller Nej på varje om land och färdigheter, börja överst.",
    "hintPlant": "Svara om du odlar egen frukt och grönsaker.",
    "hintFruitForest": "Svara om en fruktträdgård intresserar dig.",
    "hintPrepping": "Svara om du förbereder dig för katastrofer.",
    "hintCommunity": "Svara om gemenskapsjordbruk intresserar dig.",
    "hintCanning": "Svara om du konserverar mat.",
    "hintSurvival": "Svara om du har överlevnadsfärdigheter."
  },
  "family": {
    "eyebrow": "Matchning · Familj",
    "title": "Barn, trodjup, substanser",
    "text": "Vad du behöver hos en partner kring trosintensitet, barn och tidigare substansbruk.",
    "children": "Barn",
    "wants": {
      "label": "Vill ha barn",
      "hint": "Att bygga en familj är en del av visionen."
    },
    "doesNotWant": {
      "label": "Vill inte ha barn",
      "hint": "Tydligt nej till barn."
    },
    "open": {
      "label": "Öppen",
      "hint": "Urskiljande — inte låst åt något håll."
    },
    "hasLivingWith": {
      "label": "Har barn — bor med dem",
      "hint": "Barn är redan en del av vardagen."
    },
    "requiredFaith": "Minsta trosnivå du behöver hos en partner",
    "requiredFaithHint": "10% … 100%. Hård port när båda sidor har svarat.",
    "acceptsSubstances": "Acceptera tidigare substansbruk hos en partner?",
    "hintChildren": "Välj ett kort om barn.",
    "hintFaith": "Skjut den minsta trosnivå du hoppas på hos en partner.",
    "hintSubstances": "Säg om tidigare substansbruk hos en partner är acceptabelt."
  },
  "ancestry": {
    "eyebrow": "Matchning · Bakgrund",
    "title": "Bakgrundspreferenser",
    "text": "Dela din bakgrund och vad du är öppen för hos en partner. Detta formar bara ranking — det döljer aldrig någon från decket.",
    "yourBackground": "Din bakgrund (välj alla som gäller)",
    "openToPartner": "Öppen för hos en partner",
    "codeDesc": "Kod: {code}",
    "anyDesc": "Starkaste preferens för bredd — rekommenderas vid osäkerhet.",
    "preferenceOnly": "Endast preferens — inte en port.",
    "hintOwn": "Bocka i minst en bakgrund som beskriver dig. Detta hjälper bara ranking — det döljer aldrig någon.",
    "hintAccepted": "Bocka i vad du är öppen för hos en partner, eller ”Öppen — ingen preferens”."
  },
  "interests": {
    "eyebrow": "Matchning · Intressen",
    "title": "Vad du gillar",
    "text": "Välj minst ett. Överlapp hjälper ranking; tystnad bestraffas aldrig.",
    "hint": "Bocka i minst ett intresse."
  },
  "reflection": {
    "eyebrow": "Matchning · Reflektion",
    "title": "Med egna ord",
    "text": "Dessa fyra svar visas i sin helhet och poängsätts aldrig. Skriv det som är sant.",
    "describeYourself": "Beskriv dig själv",
    "lifePurpose": "Livssyfte",
    "fifteenYear": "Du och ditt livs kärlek om 15 år",
    "weaknesses": "Svagheter",
    "hintDescribe": "Beskriv dig själv med minst {min} tecken.",
    "hintPurpose": "Skriv ditt livssyfte med minst {min} tecken.",
    "hintVision": "Skriv 15-årsvisionen med minst {min} tecken.",
    "hintWeaknesses": "Namnge en svaghet med minst {min} tecken."
  },
  "profile": {
    "eyebrow": "Profil",
    "title": "Några grundläggande",
    "text": "Håll det enkelt. Kön är binärt här — man eller kvinna — för tydlig matchning.",
    "firstName": "Förnamn",
    "firstNamePlaceholder": "Som du vill bli känd",
    "age": "Ålder",
    "agePlaceholder": "18+",
    "city": "Stad",
    "cityPlaceholder": "Var du är baserad",
    "sex": "Kön",
    "maleBody": "Jag är en man.",
    "femaleBody": "Jag är en kvinna.",
    "hintName": "Skriv ditt förnamn (minst två bokstäver).",
    "hintAge": "Ålder måste vara 18 eller äldre.",
    "hintCity": "Skriv staden där du bor.",
    "hintGender": "Välj Man eller Kvinna så att matchning kan fungera."
  },
  "ready": {
    "title": "Du får träda in.",
    "textNamed": "{name}, din verifiering och setup är registrerade. Media är pending_review. Välkommen till UN8 — hitta din person, ta sedan bort appen.",
    "text": "Din verifiering och setup är registrerade. Media är pending_review. Välkommen till UN8 — hitta din person, ta sedan bort appen.",
    "summaryAria": "Setup-sammanfattning",
    "christianRules": "Kristen · regler bekräftade",
    "mediaLine": "ID · video · {photoCount} foton · kö {pending}",
    "scalesLine": "Skaler L{loyalty}/H{honesty}/P{passion}/C{commitment}",
    "genderProfession": "{gender} · {profession}",
    "sexUnset": "Kön —",
    "professionFallback": "yrke",
    "userLine": "Användare {userId}",
    "enterMatching": "Gå till matchning",
    "needGender": "Gå tillbaka till profilsteget och välj Man eller Kvinna, försök sedan igen."
  },
  "match": {
    "brandTag": "Matchning",
    "navOnboarding": "Onboarding",
    "navReview": "Granskning",
    "navMatching": "Matchning",
    "logOut": "Logga ut",
    "enterTitle": "Gå till matchning",
    "enterText": "Logga in med samma e-post som vid onboarding. Ansökan, pool, likes och matcher använder alla ditt stabila användar-id.",
    "email": "E-post",
    "emailPlaceholder": "du@exempel.com",
    "password": "Lösenord",
    "passwordPlaceholder": "Ditt lösenord",
    "logIn": "Logga in",
    "guestOr": "Eller prova en gästsession (stabilt id per webbläsare · endast demo)",
    "guestMan": "Gäst som man",
    "guestWoman": "Gäst som kvinna",
    "goOnboarding": "Gå till onboarding →",
    "guestSession": "Gästsession · demopool",
    "packTitle": "Dina fyra",
    "packSkip": "Tryck för att fortsätta",
    "newSelection": "Nytt urval",
    "backToFour": "← Tillbaka till dina fyra",
    "whoLikedTitle": "Who liked you",
    "whoLikedLocked": "Subscribe to see names on the weekly deck — inbound hearts still show on Messages.",
    "whoLikedEmpty": "No one new has liked you yet.",
    "man": "man",
    "woman": "kvinna",
    "navSelection": "Urval",
    "navMessages": "Meddelanden",
    "navProfile": "Profil",
    "tabToday": "Urval",
    "tabMatches": "Matcher ({count})",
    "yourMatches": "Dina matcher",
    "matchesSub": "Bestående ömsesidigt intresse · {count} utgående {likesWord}",
    "like": "like",
    "likes": "likes",
    "emptyMatches": "Inget ömsesidigt intresse ännu. Fortsätt att urskilja veckans urval.",
    "valuesScore": "Värderingar {score}",
    "chatOpen": " · Chatt öppen",
    "tapToChat": " · Tryck för att chatta",
    "personLine": "{name}, {age}",
    "cityValues": "{city} · Värderingar {score}",
    "noProfileYet": "Ingen profil ännu",
    "noProfileText": "Slutför onboarding, eller tryck på Onboarding högst upp och sedan Börja. Gästmatchning finns på startsidan om du bara vill titta.",
    "matchingPaused": "Matchning pausad",
    "moderationDemoNote": "Showing demo people so you can try matching while you wait.",
    "noOneYet": "Ingen att visa ännu",
    "todaysSetDone": "Det är veckans urval",
    "weeklyTitle": "Dina 4 den här veckan",
    "weeklyTitleCount": "Dina {count} den här veckan",
    "weeklyCountdown": "Nästa urval om {days} dagar",
    "weeklyCountdownOne": "Nästa urval om 1 dag",
    "weeklyCountdownSoon": "Nästa urval snart",
    "shortWeekCopy": "This week there are {count}. We never suggest someone who is not a fit.",
    "shortWeekTwo": "This week there are two. We never suggest someone who is not a fit.",
    "weekDone": "Det är veckans urval",
    "weekDoneText": "You have discerned everyone we could honestly suggest. Come back when the next selection opens.",
    "emptyNeverHad": "Det finns ännu ingen på veckans lista. Poolen fylls på — öppna Urval igen om en stund, eller kom tillbaka när fler medlemmar är godkända.",
    "emptyDone": "Du har gått igenom veckans urval. Kom tillbaka vid nästa öppning, eller återställ leken.",
    "likesMayNotStick": " Likes kanske inte fastnar.",
    "poolMeta": "Pool: {pool} · Matcher: {matches} · Likade: {liked}",
    "demoPool": "demo",
    "livePool": "{source} ({count})",
    "resetDeck": "Återställ deck",
    "backOnboarding": "Tillbaka till onboarding",
    "feedEyebrowDemo": "Veckans urval · Demo",
    "feedEyebrowLive": "Veckans urval · Pool ({source}, {count})",
    "feedTitle": "Urskilj med omsorg",
    "left": "{count} kvar",
    "pass": "Passa",
    "interested": "Intresserad",
    "swipeHint": "Swipa eller använd knapparna. En match öppnas bara när intresset är ömsesidigt och sparat.",
    "celebrationEyebrow": "Ömsesidigt intresse",
    "celebrationTitle": "Ni matchade",
    "celebrationText": "{self} och {other} visade båda intresse. Värderingsöverensstämmelse: {score}.",
    "celebrationWhyLabel": "Why you matched",
    "celebrationNote": "Chatten är upplåst för den här matchen. Håll det respektfullt — förbund före bekvämlighet.",
    "openChat": "Öppna chatt",
    "keepDiscerning": "Fortsätt urskilja",
    "cardSeeking": "Söker",
    "cardHobbies": "Hobbyer",
    "affinity": "Affinitet",
    "valuesScoreLabel": "Värderingsscore",
    "scoreStrong": "Stark överensstämmelse",
    "scoreSolid": "Solid överensstämmelse",
    "scoreModerate": "Måttlig överensstämmelse",
    "scoreDifferent": "Olika rytmer",
    "characterAxisFoot": "Karaktärsaxeln inkluderar de fyra pelarna",
    "youThem": "Du {self} · De {other}",
    "stampInterest": "Intresse",
    "stampPass": "Passa",
    "explainLikedYou": "They already liked you — this is mutual interest waiting to happen.",
    "explainLegacyClose": "Era värderingsscores ligger nära varandra ({score} av 100).",
    "explainLegacyFuller": "Ett fylligare ”varför” visas efter att ni båda slutfört matchningsfrågorna.",
    "explainFaith": "Er trosintensitet ligger nära — ni tar efterföljelse av Jesus med liknande allvar.",
    "explainCharacter": "Hur ni behandlar människor hemma stämmer överens — fred, manér och omsorg.",
    "explainPurpose": "Ni betygsatte er egen ärlighet liknande, vilket tyder på delat allvar.",
    "explainHome": "Ni delar intresse för land, odling eller ett självförsörjande hem.",
    "explainAncestry": "Ni båda föredrar liknande familjebakgrunder. Det är en preferens, inte ett filter — ingen döljs för det.",
    "explainTemperament": "Era intressen och temperament överlappar.",
    "explainFallback": "Det finns en möjlig match på svaren ni båda fyllde i.",
    "explainOverall": "Total affinitet {score} av 100.",
    "affinityAxes": {
      "faith": "Trosintensitet",
      "character": "Karaktär & uppförande",
      "purpose": "Livssyftesöverensstämmelse",
      "home": "Hem & självförsörjning",
      "ancestry": "Kulturell & bakgrundsaffinitet",
      "temperament": "Temperamentspassning"
    },
    "scaleAxes": {
      "loyalty": "Lojalitet",
      "honesty": "Ärlighet",
      "passion": "Passion",
      "commitment": "Engagemang"
    },
    "verify": {
      "brandTag": "Verify",
      "title": "Verify to message",
      "sub": "Anyone can browse and heart. A conversation needs your ID and a short confirmation video. Submitted is enough — review can wait.",
      "cta": "Add ID and video",
      "videoCta": "Add a confirmation video",
      "submitted": "ID and video are in. You can message while we review.",
      "done": "You’re verified.",
      "back": "Back",
      "continue": "Continue",
      "idEyebrow": "Identity",
      "videoEyebrow": "Presence",
      "idText": "Passport or national ID. Nothing is posted publicly. Submitted is enough to talk.",
      "videoText": "A short clip (about {seconds} seconds). Face the camera. This proves you are present."
    }
  },
  "chat": {
    "brandTag": "Chatt",
    "unavailableTitle": "Chatt otillgänglig",
    "unavailableText": "Den här matchen saknas eller hör inte till din session.",
    "backToMatches": "Tillbaka till matcher",
    "backMatches": "← Matcher",
    "valuesSubscriber": "Värderingar {score} · Prenumerant",
    "valuesTrial": "Värderingar {score} · Provperiod",
    "valuesKept": "Värderingar {score} · Match behållen",
    "empty": "Säg hej med omsorg. På den delade backend synkas meddelanden till båda telefonerna efter en ömsesidig match.",
    "placeholder": "Meddelande till {name}…",
    "ariaMessage": "Meddelande",
    "send": "Skicka"
  },
  "billing": {
    "paywallCopy": "Efter din gratis provperiod behåller du alla du redan matchat med och kan fortsätta chatta. För att se nya personer, prenumerera.",
    "signInToMatch": "Logga in för att använda matchning.",
    "signInFirst": "Logga in först.",
    "subscriberUntil": "Prenumerant · till {date}",
    "renewal": "förnyelse",
    "freeTrial": "Gratis provperiod · {days} dagar (slutar {date})",
    "soon": "snart",
    "trialEnded": "Provperiod slut · matcher & chatt förblir öppna",
    "subscribe": "Prenumerera · ${price}/mån",
    "subscribeEarly": "Prenumerera tidigt · ${price}/mån",
    "activeNote": "Prenumeration aktiv — du kan se nya personer igen.",
    "playOnly": "Subscription is Google Play Billing only (app install). There is no web checkout here.",
    "playOnlyShort": "Billing via Google Play only — no web payment."
  },
  "auth": {
    "recoveryTitle": "Spara din återställningskod",
    "recoveryText": "Skriv ner detta nu. Det visas en gång. Om du förlorar din lösenfras är denna kod det enda sättet att återställa den i det slutna testet.",
    "savedContinue": "Jag har sparat den — fortsätt",
    "welcomeBack": "Välkommen tillbaka",
    "createAccount": "Skapa ditt konto",
    "intro": "Handle och lösenfras. Ingen e-post eller SMS skickas. Ditt id förblir stabilt över onboarding, granskning och matchning.",
    "tabLogin": "Logga in",
    "tabRegister": "Registrera",
    "handle": "Handle",
    "handlePlaceholder": "du@exempel.com eller ett kort handle",
    "passphrase": "Lösenfras",
    "passphrasePlaceholder": "Minst 8 tecken",
    "submitLogin": "Logga in",
    "submitRegister": "Skapa konto",
    "backWelcome": "Tillbaka till välkomst"
  },
  "options": {
    "origin": {
      "african": "Afrikansk",
      "european": "Europeisk",
      "asian": "Asiatisk",
      "latino": "Latino / Hispanic",
      "middleEastern": "Mellanöstern",
      "indigenous": "Ursprungsbefolkning",
      "mixed": "Blandad",
      "other": "Annat",
      "dutch": "Nederländsk",
      "german": "Tysk",
      "any": "Öppen — ingen preferens"
    },
    "interest": {
      "prayer": "Bön",
      "worship": "Tillbedjan",
      "reading": "Läsning",
      "hiking": "Vandring",
      "music": "Musik",
      "cooking": "Matlagning",
      "farming": "Jordbruk / trädgård",
      "sports": "Sport",
      "missions": "Mission",
      "family": "Familjeliv",
      "crafts": "Hantverk",
      "outdoors": "Utomhus"
    }
  },
  "capture": {
    "yesNoDefaults": {
      "yes": "Ja",
      "no": "Nej"
    },
    "id": {
      "titleEmpty": "Myndighets-ID",
      "titleReady": "ID klart",
      "hintEmpty": "Pass eller nationellt ID. Ta ett livefoto, eller välj en bild/PDF. Alla fyra hörn synliga.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "savedSuffix": " · sparat",
      "previewAlt": "Förhandsvisning av myndighets-ID",
      "pdfAria": "PDF-dokument valt",
      "takePhoto": "Ta foto",
      "retake": "Ta om",
      "chooseFile": "Välj fil",
      "replaceFile": "Byt fil",
      "remove": "Ta bort",
      "uploading": "Laddar upp…",
      "cameraTitle": "Fotografera ditt ID",
      "signIn": "Logga in innan du laddar upp ID.",
      "uploadFailed": "Uppladdning misslyckades. Försök igen.",
      "badFile": "Kunde inte använda den här filen."
    },
    "video": {
      "titleEmpty": "Bekräftelsevideo",
      "titleLive": "Kamera live",
      "titleReady": "Video klar",
      "hintEmpty": "Säg ditt förnamn och att du går med i UN8 ärligt. 5–15 sekunder.",
      "hintReady": "{fileName} · {bytes}{saved}",
      "rec": "REC {seconds}s",
      "record": "Spela in",
      "cameraUpload": "Kamerauppladdning",
      "chooseFile": "Välj fil",
      "startRecording": "Starta inspelning",
      "cancel": "Avbryt",
      "stopSave": "Stoppa & spara",
      "recordAgain": "Spela in igen",
      "replaceFile": "Byt fil",
      "remove": "Ta bort",
      "unsupported": "Liveinspelning är inte tillgänglig här. Använd kamerauppladdning eller välj en fil.",
      "permissionDenied": "Kamerabehörighet nekad. Du kan fortfarande ladda upp en kort videofil.",
      "signIn": "Logga in innan du laddar upp video.",
      "uploadFailed": "Uppladdning misslyckades. Försök igen.",
      "saveFailed": "Kunde inte spara inspelningen.",
      "badVideo": "Kunde inte använda den här videon."
    },
    "photos": {
      "count": "{count} / {max} foton",
      "minimumMet": "Minimum uppfyllt",
      "moreRequired": "{n} till krävs",
      "listAria": "Verifieringsfoton",
      "photoAlt": "Foto {n}",
      "removeAria": "Ta bort foto {n}",
      "camera": "Kamera",
      "takePhoto": "Ta foto",
      "chooseFiles": "Välj filer",
      "uploading": "Laddar upp…",
      "hint": "Ta foto öppnar livekameran. Välj filer är bara för gallerival. Tydliga ansiktsbilder — inga filter som döljer identitet. Max {max}.",
      "cameraTitle": "Ta ett foto av dig själv",
      "signIn": "Logga in innan du laddar upp foton.",
      "someFailed": "Vissa foton misslyckades att laddas upp. Försök igen med de som misslyckades.",
      "addFailed": "Kunde inte lägga till foton."
    },
    "liveStill": {
      "titleDefault": "Kamera",
      "close": "Stäng",
      "capture": "Fånga",
      "cancel": "Avbryt",
      "hint": "Håll stadigt. Livekameran förblir öppen tills du fångar.",
      "unavailable": "Kameran är inte tillgänglig i den här webbläsaren. Använd Välj fil istället.",
      "permissionDenied": "Kamerabehörighet nekad eller otillgänglig. Använd Välj fil istället.",
      "frameFailed": "Kunde inte fånga den här bilden.",
      "saveFailed": "Kunde inte spara fotot."
    },
    "uploadStatus": {
      "uploading": "laddar upp…",
      "failed": "uppladdning misslyckades",
      "savedLocally": "sparat lokalt",
      "uploaded": "uppladdat",
      "stored": "lagrat",
      "awaitingUpload": "Väntar på uppladdning",
      "localFallbackNote": "{error} Filen är sparad på den här enheten; försök igen när sign-endpointen är uppe."
    }
  },
  "language": {
    "label": "Språk",
    "choose": "Välj språk"
  },
  "shell": {
    "back": "Tillbaka",
    "goBackAria": "Gå tillbaka"
  }
} as Messages;
